<ul [ngClass]="{'rounded': !embedded, 'list-group-flush': embedded}" class="list-group">
    <li [ngClass]="{'list-group-heading bg-light': !embedded, 'px-4': embedded}"
        class="d-none d-md-block list-group-item py-2">
        <div class="row align-items-center font-weight-bold">
            <div class="col-2">
                {{ 'portal.invoices.columns.date' | translate }}
            </div>
            <div class="col-3">
                {{ 'portal.invoices.index-page.index.detail.summary.payment-reference' | translate }}
            </div>
            <div class="col text-right">
                {{ 'portal.invoices.index-page.index.pay-invoice-modal.paid-amount' | translate }}
                <div *ngIf="withInvoiceDetails" class="font-weight-normal small">{{ 'portal.invoices.columns.total' | translate }}</div>
            </div>
            <div *ngIf="withInvoiceDetails" class="col-md-2 text-right">
                {{ 'portal.invoices.index-page.index.pay-invoice-modal.paid-amount' | translate }}
                <div class="font-weight-normal small">{{ 'portal.invoices.index-page.index.detail.summary.this-invoice' | translate }}</div>
            </div>
            <div *ngIf="embedded" class="col-1"></div>
        </div>
    </li>

    <ng-container *ngIf="!(loading && hideWhileLoading)">
        <li
            *ngFor="let payment of payments"
            [embedded]="embedded"
            [ngClass]="{'px-4': embedded}"
            [payment]="payment"
            [routerLink]="['/my-portal', 'payments', payment.id]"
            [withInvoiceDetails]="withInvoiceDetails"
            class="list-group-item list-group-item-action"
            qwyk-payments-list-view-item
        >
        </li>
    </ng-container>

    <li
        *ngIf="!embedded && payments && payments.length === 0 && !loading"
        class="list-group-item text-center py-4">
        <h5 class="font-weight-normal">{{ 'common.no-items-found-short' | translate : { value: 'portal.invoices.index-page.index.detail.tabs.payments' | translate } }}</h5>
        <p class="mb-0">
            {{ 'common.no-items-found-long' | translate : { value: 'portal.invoices.index-page.index.detail.tabs.payments' | translate } }}
        </p>
    </li>

    <li
        *ngIf="embedded && !loading && (!payments || !payments.length)"
        icon="list"
        qwyk-list-item-nothing-found
        resource="{{ 'portal.invoices.index-page.index.detail.tabs.payments' | translate | lowercase }}"
    ></li>

    <li
        *ngIf="embedded && loading"
        qwyk-list-item-loader
        resource="{{ 'portal.invoices.index-page.index.detail.tabs.payments' | translate | lowercase }}"
    ></li>

    <li *ngIf="!embedded && loading" class="list-group-item text-center py-4">
        <fa-icon
            [icon]="['far', 'spinner']"
            [pulse]="true"
            class="mb-3"
            size="lg"
        ></fa-icon>
        <h5 class="font-weight-normal m-0 mt-3">
            {{ 'common.your-transactions-are-being-loaded' | translate : { value: 'portal.invoices.index-page.index.detail.tabs.payments' | translate | lowercase } }}
        </h5>
    </li>
</ul>
